<template>
	<StageCard
		:type="type"
		tip-position="none"
		:compact="compact"
		:selected="selected"
		:data-qa-stage-node="nodeNumber"
		:data-qa-stage-status-name="statLabel"
		:data-qa-stage-status-text="statusText"
		:data-qa-stage-status-type="type"
		@click="handleClick"
	>
		<template #header>
			<div class="title">stage {{ nodeNumber }}</div>
			<Icon
				v-if="!infoIconState.remove"
				:disabled="infoIconState.disabled"
				name="info"
				type="filled"
				size="medium"
				@click="handleIClick"
			/>
		</template>
		<StageStatistics
			:type="type"
			:name="statLabel"
			:number="nodeNumber"
			:status-text="statusText"
		/>
		<template #footer>
			<StageStatus :type="type" :status="status" />
		</template>
	</StageCard>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";
import StageCard from "./../StageCard/StageCard";
import StageStatus from "./../StageCard/StageStatus";
import StageStatistics from "./../StageCard/StageStatistics";

export default defineComponent({
	name: "DagNode",
	components: {
		Icon,
		StageCard,
		StageStatus,
		StageStatistics
	},
	computed: {
		infoIconState() {
			return {
				disabled: this.infoIcon ? this.infoIcon.disabled : false,
				remove: this.infoIcon ? this.infoIcon.remove : false
			};
		},
		statLabel() {
			return this.label ? this.label : this.name;
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event.
			 *
			 * @event click
			 */
			this.$emit("click", e);
		},

		handleIClick(e) {
			/**
			 * I Icon Click event.
			 *
			 * @event click
			 */
			this.$emit("iclick", e);
		}
	}
});
</script>
